<template>
  <button
    :class="{dark: isDark, [size]: size, disabled: (!epi || !epi.id) && size !== 'size-mini'}"
    :disabled="(!epi || !epi.id) && size !== 'size-mini'"
    :aria-label="`Speed Rate ${rate}x`"
    class="controls-speed"
    @click.prevent="playbackRate"
    @touchstart.prevent="playbackRate"
  >
    {{ rate }}x
  </button>
</template>

<script>
import Store from '../store'

export default {
  data () {
    return {
      rate: Store.state.audio.playbackRate || 1,
      store: Store
    }
  },
  computed: {
    epi () { return this.store.state.episode },
    isDark () { return this.store.state.isDark },
    size () { return this.store.state.size }
  },
  methods: {
    playbackRate () {
      this.store.incrementPlaybackRate()
      this.rate = this.store.state.audio.playbackRate
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

button {
  align-self: center;
  background: none;
  border-radius: 4px;
  border: solid 1px $black-800;
  color: $black-800;
  cursor: pointer;
  height: 20px;
  line-height: 18px;
  margin: 0;
  padding: 0;
  text-align: center;
  text-transform: uppercase;
  width: 32px;

  &.size-mini {
    align-items: center;
    border-width: 1px;
    height: 16px;
    line-height: 0;
    margin-bottom: 4px;
    opacity: .95;
    transition: opacity .2s;

    &:hover {
      opacity: .6;
    }
  }
  &.dark {
    border: solid 1px $white-000;
    color: $white-000;
  }
  &.disabled {
    background-color: transparent;
    border-color: $grey-300;
    color: $grey-300;
    cursor: default;
    &.dark {
      border-color: $grey-700;
      color: $grey-700;
    }
  }

  @include font-xs-embed(700);
}
</style>
